import React, { Component } from "react";
import { Col, Button, Row, Table, Container } from "react-bootstrap";
import "../HostelAttendance/_hostelattendance.scss"
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import { gql } from "apollo-boost";
import * as Cookies from "es-cookie"
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import SubmitHostelAttendanceModal from "./SubmitHostelAttendanceModal";
import { HostelShimmer } from "./HostelShimmer";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) { super(props); this.state = { open: false }; this.ref = React.createRef(); }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => { if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false }); };
    toggle = (id) => { const { value, onChange } = this.props; onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]); };
    render() {
        const { options, value, placeholder, onChange, disabled } = this.props;
        const { open } = this.state;
        const label = value.length === 0 ? placeholder : value.length === options.length ? `All (${options.length})` : value.length === 1 ? (options.find((o) => o.value === value[0])?.label || `${value.length} selected`) : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => { if (!disabled) this.setState({ open: !open }); }} style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: disabled ? "#f1f5f9" : "#f9fafb", cursor: disabled ? "not-allowed" : "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 42 }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && !disabled && (
                    <div className="cbx-dd-panel" style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 240, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))} style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)} style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const FIN = {
    wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
    card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
    cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
    iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
    cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
    cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
    cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
    filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
    label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
    select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
    dateInput: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "8px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", height: 40 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
    btnSuccess: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#059669", color: "#fff", border: "none", borderRadius: 9, padding: "10px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    content: { padding: "20px 24px" },
};

class HostelAttendanceSection extends Component {
    constructor() {
        super();
        this.state = {
            branches: [],
            branchSearchval: "",
            branchSearch: 0,
            branchError: "",
            buildingSearch: "",
            buildingError: "",
            buildingName: "",
            floorSearch: "",
            floorError: "",
            floorName: "",
            roomSearch: "",
            roomError: "",
            roomName: "",
            defaultvalue: 0,
            getBuildingDetails: [],
            getFloors: [],
            getRooms: [],
            roomOptions: [],
            selectedRooms: [],
            capacityDetails: [],
            date: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            loading: 0,
            showtable: false,
            modalShow1: false,
            totalStudents: 0,
            presentStudents: 0,
            absentStudents: 0,
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10,
            initialLoad: true,
            allStudents: [],
        }
    }

    // Branch students from edu_students (so allocated students missing from
    // getNewEducationalStudents — no class/section — still resolve to a name).
    fetchBranchStudents = async () => {
        try {
            const results = await Promise.all(this.scopedBranchIds().map((branch_id) => this.props.client.query({
                query: gql`
                    query($institute_id: Int, $branch_id: Int){
                        getAllotmentStudents(institute_id: $institute_id, branch_id: $branch_id){
                            student_id
                            student_name
                            roll_no
                        }
                    }
                `,
                variables: { institute_id: parseInt(Cookies.get("institutionid")), branch_id: branch_id },
                fetchPolicy: 'network-only',
            })));
            this.setState({ allStudents: results.flatMap((r) => (r.data && r.data.getAllotmentStudents) || []) });
        } catch (e) {
            console.error("fetchBranchStudents error", e);
            this.setState({ allStudents: [] });
        }
    };

    async componentDidMount() {
        await this.getBranches();
        this.setState({ initialLoad: false });
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // The branches this page covers. There is no branch picker here any more.
    scopedBranchIds = () => (this.state.branches || []).map((b) => parseInt(b.id));

    getBranches = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            // The header's branch selection (NavbarOne) IS this page's branch filter.
            const branches = scopeBranches(result.data.getBranches || []);
            if (branches.length > 0) {
                this.setState({
                    branches,
                    buildingSearch: "", buildingError: "", floorSearch: "", floorError: "",
                    roomSearch: "", roomError: "", getFloors: [], getRooms: [], roomOptions: [],
                    selectedRooms: [], capacityDetails: [], showtable: false,
                    totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
                }, () => {
                    this.getBuildingCreationDetails();
                    this.fetchBranchStudents();
                });
            } else {
                this.setState({ branches: [], getBuildingDetails: [], allStudents: [] });
            }
        } catch (err) {
            console.error("hostel getBranches error", err);
        }
    };

    // onBranchChange removed — the header (NavbarOne) owns branch selection now.

    // getEmployees / getBuildingCreationDetails each take a single branch_id, so both
    // are fanned out across the header's branch scope and concatenated.
    getBuildingCreationDetails = async () => {
        const branchIds = this.scopedBranchIds();
        let employeesData = [];
        const results1 = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  employee_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: branch_id,
            },
            fetchPolicy: 'network-only'
        })));

        employeesData = results1.flatMap((r) => (r.data && r.data.getEmployees) || []);

        const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
            query: gql`
        query($institute_id: Int!, $branch_id: Int!, $fromDate: String!){
            getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id, fromDate: $fromDate ) {
                hostel_building_id
                hostel_building_name
                floors_details{
                  floor_id
                  floor_name
                  floor_incharge_id
                  rooms_details{
                    room_id
                    room_name
                    room_capacity
                    capacity_details{
                      edu_student_id
                      attendance_status
                    }
                  }
                }
            }
        }
        `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: branch_id,
                fromDate: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        })))

        const allBuildings = results.flatMap((r) => (r.data && r.data.getBuildingCreationDetails) || [])
        if (allBuildings.length > 0 && employeesData.length > 0) {
            let filter_data = allBuildings

            if (filter_data.length > 0) {
                let data = [];

                if (Cookies.get("userlevel") == 8) {
                    filter_data.map((item) => {
                        let floorData = [];
                        item.floors_details.map((item1) => {
                            if (item1.floor_incharge_id.includes(Cookies.get("id"))) {
                                floorData.push({ ...item1 })
                            }
                        })
                        if (floorData.length > 0) {
                            data.push({ ...item, floors_details: floorData })
                        }
                    })
                } else {
                    data = filter_data
                }

                this.setState({
                    getBuildingDetails: data,
                    loading: 0
                })
                return data;
            }
        }
        else {
            this.setState({
                getBuildingDetails: [],
                loading: 0
            })
            return [];
        }
        return [];
    }

    // Refresh the attendance table in place after a submit (no full page reload),
    // keeping the current branch/building/floor/room selection.
    refreshAfterSubmit = async () => {
        this.setState({ modalShow1: false });
        if (!this.state.branchSearch || !this.state.buildingSearch || !this.state.floorSearch) return;
        const data = await this.getBuildingCreationDetails();
        const building = (data || []).find((a) => a.hostel_building_id == this.state.buildingSearch);
        if (!building) return;
        const getFloors = building.floors_details;
        const floor = getFloors.find((a) => a.floor_id == this.state.floorSearch);
        const getRooms = floor ? floor.rooms_details : [];
        this.setState({ getFloors, getRooms }, () => this.handleSubmit1());
    };

    handleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "date") {
            this.setState({
                date: value,
                buildingSearch: "", buildingName: "", buildingError: "",
                floorSearch: "", floorError: "", roomSearch: "", roomError: "",
                getFloors: [], getRooms: [], roomOptions: [], selectedRooms: [], capacityDetails: [],
                showtable: false, totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
            })
            setTimeout(() => {
                this.getBuildingCreationDetails();
            }, 100)
        }

        if (name == "buildingSearch") {
            let getFloors = []
            if (value != 0) {
                getFloors = this.state.getBuildingDetails.filter((a) => a.hostel_building_id == value)[0].floors_details
                const selectedBuilding = this.state.getBuildingDetails.find(a => a.hostel_building_id == value);

                this.setState({
                    buildingSearch: value,
                    buildingName: selectedBuilding.hostel_building_name,
                    buildingError: "", floorSearch: "", floorError: "", roomSearch: "", roomError: "",
                    getFloors: getFloors, capacityDetails: [], getRooms: [], roomOptions: [], selectedRooms: [],
                    showtable: false, totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
                })
            } else {
                this.setState({
                    buildingSearch: "", buildingName: "", buildingError: "", floorSearch: "", floorError: "",
                    roomSearch: "", roomError: "", getFloors: [], capacityDetails: [], getRooms: [], roomOptions: [], selectedRooms: [],
                    showtable: false, totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
                })
            }
        }

        if (name == "floorSearch") {
            let getRooms = []
            if (value != 0) {
                getRooms = this.state.getFloors.filter((a) => a.floor_id == value)[0].rooms_details;
                const selectedFloor = this.state.getFloors.find(a => a.floor_id == value)
                let roomOptions = [];
                if (getRooms.length > 0) {
                    getRooms.map((item) => {
                        const newObj = { value: item.room_id, label: item.room_name }
                        roomOptions.push(newObj)
                    })
                }
                this.setState({
                    floorSearch: value,
                    floorName: selectedFloor.floor_name,
                    floorError: "", roomSearch: "", roomName: "", roomError: "",
                    getRooms: getRooms,
                    roomOptions: roomOptions.sort((a, b) => a.value - b.value),
                    selectedRooms: roomOptions.sort((a, b) => a.value - b.value),
                    capacityDetails: [], showtable: false, totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
                })
            } else {
                this.setState({
                    floorSearch: "", floorName: "", floorError: "", roomSearch: "", roomError: "", roomName: "",
                    getRooms: [], roomOptions: [], selectedRooms: [], capacityDetails: [],
                    showtable: false, totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
                })
            }
        }
    }

    handleSubmit1 = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        if (this.state.buildingSearch == "") {
            this.setState({ buildingError: "Please select Building" })
            return ""
        }
        if (this.state.floorSearch == "") {
            this.setState({ floorError: "Please select Floor" })
            return ""
        }
        if (!this.state.selectedRooms.length) {
            this.setState({ roomError: "Please select Room" });
            return ""
        }

        this.setState({ loading: 1 })

        let studentsData = [];

        this.state.selectedRooms.map((item) => {
            let roomWiseData = this.state.getRooms.filter((item1) => item1.room_id == item.value);
            if (roomWiseData[0].capacity_details.length > 0) {
                // Only beds with an actual allocated student (skip empty beds),
                // and de-duplicate so a student isn't listed twice.
                let allocated = roomWiseData[0].capacity_details.filter(
                    (c, i, arr) => c.edu_student_id && arr.findIndex((o) => o.edu_student_id == c.edu_student_id) === i
                );
                allocated.map((item3) => {
                    studentsData.push({ ...item3, roomName: roomWiseData[0].room_name, roomSearch: roomWiseData[0].room_id })
                })
            }
        })

        let totalStudents = 0;
        let no_of_absent = 0;
        let no_of_present = 0;
        let students_attendance_data = [];

        if (studentsData.length > 0) {
            studentsData.map((item) => {
                // Show only bed-allocated students that resolve to a real student
                // record (edu_students first, then the academic list). Allocations
                // for deleted/unknown students are skipped.
                let resolved = (this.state.allStudents || []).find((a) => a.student_id == item.edu_student_id)
                    || this.props.getNewEducationalStudents.find((a) => a.student_id == item.edu_student_id);
                if (resolved && resolved.student_name) {
                    students_attendance_data.push({ ...item, ...resolved })
                }
            });

            totalStudents = students_attendance_data.length;
            no_of_present = students_attendance_data.filter(student => student.attendance_status === 1).length;
            no_of_absent = students_attendance_data.filter(student => student.attendance_status === 0).length;
        }
        let students_attendance_sorted_data = students_attendance_data.sort((a, b) => {
            if (a.attendance_status < b.attendance_status) { return -1; }
            else if (a.attendance_status > b.attendance_status) { return 1; }
            if (a.roll_no < b.roll_no) { return -1; }
            else if (a.roll_no > b.roll_no) { return 1; }
            return 0;
        });

        this.setState({ capacityDetails: students_attendance_sorted_data, totalStudents: totalStudents, presentStudents: no_of_present, absentStudents: no_of_absent, currentPageStartCount: 0, currentPageEndCount: 10 })

        setTimeout(() => {
            this.setState({ showtable: true, loading: 0 })
        }, 1000);
    }

    presentOrAbsent(e, row) {
        let studentAttendanceData = []
        studentAttendanceData = this.state.capacityDetails.map((item) => {
            if (item.edu_student_id == row.edu_student_id) {
                if (e.target.value == 1) { return { ...item, attendance_status: 1 } }
                else if (e.target.value == 0) { return { ...item, attendance_status: 0 } }
            } else {
                return { ...item }
            }
        });
        let totalStudents = this.state.capacityDetails.length;
        let no_of_present = studentAttendanceData.filter((item) => item.attendance_status == 1).length;
        let no_of_absent = studentAttendanceData.filter((item) => item.attendance_status == 0).length;
        this.setState({ capacityDetails: studentAttendanceData, totalStudents: totalStudents, presentStudents: no_of_present, absentStudents: no_of_absent })
    }

    // Mark every loaded student present (1) or absent (0) at once.
    markAll = (status) => {
        const data = this.state.capacityDetails.map((item) => ({ ...item, attendance_status: status }));
        this.setState({
            capacityDetails: data,
            totalStudents: data.length,
            presentStudents: status == 1 ? data.length : 0,
            absentStudents: status == 0 ? data.length : 0,
        });
    }

    searchFilter = (e) => {
        let value = e.target.value
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    }

    pageChange = (pageNumber) => {
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    handleRoomChange = (ids) => {
        const sel = this.state.roomOptions.filter((o) => ids.includes(o.value));
        this.setState({
            selectedRooms: sel,
            roomName: sel.length > 0 ? sel[0].label : "",
            capacityDetails: [], roomError: "", showtable: false,
            totalStudents: 0, presentStudents: 0, absentStudents: 0, search: "",
        });
    }

    render() {
        if (this.state.initialLoad) {
            return this.props.embedded
                ? <div style={{ padding: 40, textAlign: "center" }}><div className="spinner-border text-primary" /></div>
                : <HostelShimmer filters={5} />;
        }

        let filterStudentData = this.state.capacityDetails;
        if (this.state.search != "") {
            filterStudentData = this.state.capacityDetails.filter((item) => item.roll_no.includes(this.state.search) || item.student_name.toLowerCase().includes(this.state.search.toLowerCase()) || item.roomName.toLowerCase().includes(this.state.search.toLowerCase()))
        }
        let pages = Math.ceil(filterStudentData.length / 10);
        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);


        return (
            <div style={this.props.embedded ? { marginBottom: 0 } : FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={this.props.embedded ? { ...FIN.card, border: "none", boxShadow: "none" } : FIN.card}>
                        {/* Header */}
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-bed" /></div>
                            <div style={FIN.cardTitleText}>
                                <h5 style={FIN.cardTitle}>Hostel Attendance</h5>
                                <span style={FIN.cardSubtitle}>Mark room-wise hostel attendance</span>
                            </div>
                            <div style={{ marginLeft: "auto" }}>
                                <input type="date" style={FIN.dateInput} name="date" value={this.state.date} onChange={this.handleInputChange} max={this.state.currentDate} />
                            </div>
                        </div>

                        {/* Filters */}
                        <div style={FIN.filterBar}>
                            <Row className="g-2 align-items-end">
                                {/* No Branch picker — the header (NavbarOne) scopes this page. */}
                                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Building Name</label>
                                    <select style={FIN.select} name="buildingSearch" onChange={this.handleInputChange} value={this.state.buildingSearch}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {[...this.state.getBuildingDetails]
                                            .sort((a, b) => b.hostel_building_id - a.hostel_building_id)
                                            .map(buildname => (
                                                <option key={buildname.hostel_building_id} value={buildname.hostel_building_id}>{buildname.hostel_building_name}</option>
                                            ))}
                                    </select>
                                    {this.state.buildingError ? <span style={FIN.err}>{this.state.buildingError}</span> : null}
                                </Col>
                                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Floor Name</label>
                                    <select style={FIN.select} name="floorSearch" onChange={this.handleInputChange} value={this.state.floorSearch}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {this.state.getFloors.map(floor => (
                                            <option key={floor.floor_id} value={floor.floor_id}>{floor.floor_name}</option>
                                        ))}
                                    </select>
                                    {this.state.floorError ? <span style={FIN.err}>{this.state.floorError}</span> : null}
                                </Col>
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Room Name</label>
                                    <CheckboxDropdown
                                        options={this.state.roomOptions}
                                        value={this.state.selectedRooms.map(r => r.value)}
                                        onChange={this.handleRoomChange}
                                        placeholder="Select Room(s)"
                                        disabled={this.state.getRooms.length === 0}
                                    />
                                    {this.state.roomError ? <span style={FIN.err}>{this.state.roomError}</span> : null}
                                </Col>
                                <Col xl={1} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={{ ...FIN.label, visibility: "hidden" }}>Get</label>
                                    <button style={{ ...FIN.btnPrimary, width: "100%", height: 42, padding: "8px 10px", whiteSpace: "nowrap", background: "linear-gradient(135deg, rgb(16, 185, 129) 0%, rgb(5, 150, 105) 100%)" }} title="Get Students" onClick={(e) => { this.handleSubmit1(e) }}>
                                        <i className="fas fa-search" />
                                        <span className="get-students-label">Get Students</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>

                        {/* Content */}
                        <div style={FIN.content}>
                            {this.state.loading == 1 ? (
                                <div style={{ textAlign: "center", padding: "30px 0" }}><div className="spinner-border text-primary" /></div>
                            ) : this.state.showtable ? (
                                this.state.capacityDetails.length > 0 ? (
                                    <>
                                        {/* Summary chips */}
                                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
                                            {[
                                                { label: "Total", value: this.state.totalStudents, tint: "#eef2ff", color: "#4f46e5" },
                                                { label: "Present", value: this.state.presentStudents, tint: "#ecfdf5", color: "#059669" },
                                                { label: "Absent", value: this.state.absentStudents, tint: "#fef2f2", color: "#dc2626" },
                                            ].map((c) => (
                                                <div key={c.label} style={{ background: c.tint, borderRadius: 12, padding: "10px 18px", minWidth: 110 }}>
                                                    <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>{c.label}</div>
                                                    <div style={{ fontSize: 22, fontWeight: 800, color: c.color }}>{c.value}</div>
                                                </div>
                                            ))}
                                        </div>

                                        <p style={{ color: "#dc2626", fontSize: 13, marginBottom: 12 }}>Note: By default all students are marked as present. Change to mark as absent.</p>

                                        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
                                            <div style={{ flex: "1 1 220px", maxWidth: 280 }}>
                                                <input type="text" placeholder="Search name / roll / room" name="search" style={{ ...FIN.select, width: "100%" }} onChange={(e) => this.searchFilter(e)} />
                                            </div>
                                            <button style={{ ...FIN.btnPrimary, background: "#059669", height: 42 }} onClick={() => this.markAll(1)}>
                                                <i className="fas fa-check-double" /> All Present
                                            </button>
                                            <button style={{ ...FIN.btnPrimary, background: "#dc2626", height: 42 }} onClick={() => this.markAll(0)}>
                                                <i className="fas fa-times-circle" /> All Absent
                                            </button>
                                        </div>

                                        <div className="hostel_attendance_table">
                                            <Table striped bordered hover className="text-center mb-0">
                                                <thead style={{ background: "#f8fafc", color: "#475569" }}>
                                                    <tr>
                                                        <th>Student Name</th>
                                                        <th>Roll No</th>
                                                        <th>Building</th>
                                                        <th>Floor</th>
                                                        <th>Room</th>
                                                        <th>Attendance Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pagewiseFilterData.map((item, idx) => {
                                                        let attendance_status = [{ value: 1, label: "Present" }, { value: 0, label: "Absent" }];
                                                        return (
                                                            <tr key={idx}>
                                                                <td data-label="Student Name">{item.student_name}</td>
                                                                <td data-label="Roll No">{item.roll_no}</td>
                                                                <td data-label="Building">{this.state.buildingName}</td>
                                                                <td data-label="Floor">{this.state.floorName}</td>
                                                                <td data-label="Room">{item.roomName}</td>
                                                                <td data-label="Attendance Status">
                                                                    <select className={item.attendance_status == "0" ? "selectWithColors" : "selectWithOutColors"} value={item.attendance_status} onChange={(e) => { this.presentOrAbsent(e, item) }}>
                                                                        {attendance_status.map((item1) => (
                                                                            <option key={item1.value} value={item1.value}>{item1.label}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                        <Row className="mt-3">
                                            <Col className="d-flex justify-content-start align-items-center flex-wrap" style={{ gap: 6 }}>
                                                {pages > 1 && Array.from({ length: pages }, (_, index) => {
                                                    const active = this.state.currentPageStartCount / 10 == index;
                                                    return (
                                                        <button key={index} onClick={() => this.pageChange(index + 1)}
                                                            style={{ border: active ? "1.5px solid #6366f1" : "1.5px solid #e5e7eb", background: active ? "#6366f1" : "#fff", color: active ? "#fff" : "#374151", borderRadius: 8, padding: "5px 11px", cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 500, minWidth: 34 }}>
                                                            {index + 1}
                                                        </button>
                                                    );
                                                })}
                                            </Col>
                                            <Col>
                                                <div className="d-flex justify-content-end">
                                                    <button style={FIN.btnSuccess} onClick={() => this.setState({ modalShow1: true })}>
                                                        <i className="fas fa-check" /> Submit Attendance
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                                        <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-user-slash" /></div>
                                        <h6 style={{ color: "#64748b" }}>No students available</h6>
                                    </div>
                                )
                            ) : null}
                        </div>
                    </div>
                </Container>

                <SubmitHostelAttendanceModal
                    show={this.state.modalShow1}
                    onHide={() => this.setState({ modalShow1: false })}
                    onSubmitted={this.refreshAfterSubmit}
                    stateData={this.state}
                />
            </div>
        )
    }
}

export default withRouter(withApollo(HostelAttendanceSection));
